import React, {useState} from "react";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Sidebar/Sidebar.scss";

export const GenericPageLeft = () => {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <div>
      {showMenu === false ? (
        <button
          className="menu-mobile"
          onClick={() => setShowMenu(true)}
        ></button>
      ) : (
        <button
          className="menu-mobile active"
          onClick={() => setShowMenu(false)}
        ></button>
      )}
      {showMenu && (
        <div
          className="sidebar-backdrop"
          onClick={() => setShowMenu(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999998
          }}
        />
      )}
      <div className={showMenu === true ? "left show pt-5" : "left  pt-5"}>
        <Sidebar />
      </div>
    </div>
  );
};
